var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import infraService from "@/core/services/infraService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Fuso_HorarioActions } from "@/store/enums/InfraEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Fuso_HorarioModule = class Fuso_HorarioModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Fuso_HorarioActions.POST_FUSO_HORARIO](data) {
        return new Promise(resolve => {
            infraService.post("Fuso_Horario/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Fuso_HorarioActions.PUT_FUSO_HORARIO](data) {
        return new Promise(resolve => {
            infraService.put("Fuso_Horario/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Fuso_HorarioActions.DELETE_FUSO_HORARIO](data) {
        return new Promise(resolve => {
            infraService.delete("Fuso_Horario/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Fuso_HorarioActions.DELETE_RANGE_FUSO_HORARIO](data) {
        return new Promise(resolve => {
            infraService.delete("Fuso_Horario/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Fuso_HorarioActions.FILTER_FUSO_HORARIO](data) {
        return new Promise(resolve => {
            infraService.post("Fuso_Horario/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Fuso_HorarioActions.GET_FUSO_HORARIO]() {
        return new Promise(resolve => {
            infraService.get("Fuso_Horario/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Fuso_HorarioActions.GETWITHDISABLED_FUSO_HORARIO]() {
        return new Promise(resolve => {
            infraService.get("Fuso_Horario/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Fuso_HorarioActions.GET_BY_ID_FUSO_HORARIO](data) {
        return new Promise(resolve => {
            infraService.get("Fuso_Horario/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fuso_HorarioModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fuso_HorarioModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fuso_HorarioModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fuso_HorarioModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fuso_HorarioModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Fuso_HorarioModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Fuso_HorarioModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Fuso_HorarioModule.prototype, _h, null);
Fuso_HorarioModule = __decorate([
    Module
], Fuso_HorarioModule);
export default Fuso_HorarioModule;
//# sourceMappingURL=Fuso_HorarioModule.js.map